import {FC} from "react";
import {UnityAttendanceTabContent} from "./content";
import {useOutletContext} from "react-router-dom";
import {Unity} from "../../../../domain/unity";

export const UnityAttendance: FC = () => {
    const unity = useOutletContext() as Unity;
    return <UnityAttendanceTabContent unity={unity}/>;
};
